import { toPlainText } from '@portabletext/react'

import type { SanityTextContentProps } from '@slite/components'

const WORDS_PER_MINUTE = 250
const ROUND_UP_TO_MINUTES = 5

// Rounded up to the next five minutes so the number reads as an estimate
// rather than a measurement.
export function estimateReadingTimeMinutes(
  content: SanityTextContentProps
): number {
  const wordCount = toPlainText(content).trim().split(/\s+/).length
  const minutes = wordCount / WORDS_PER_MINUTE
  return Math.ceil(minutes / ROUND_UP_TO_MINUTES) * ROUND_UP_TO_MINUTES
}
